// esbuild makes defining these with env vars more complicated than should be in
// the future it would be good to review and chnage how these values are defined

export default /dev=true/.test(window.location.search)
  || window.location.hostname === 'd1lgnpm8s0lte0.cloudfront.net'
  || window.location.hostname === 'd31rumyqhy6b1w.cloudfront.net'
